module.exports = __webpack_public_path__ + "img/mucinex_dm_max_strength_12_hour_cough.ed02339c.png";